import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import EntityId = com.eidu.sharedlib.entity.EntityId
import fetchAuthorized from '../../authorization/fetchAuthorized'

type InviteAuthUserParameters = {
  entityId: EntityId
}

export enum InviteAuthUserResult {
  Success,
  UserUnavailable,
}

const inviteAuthUser = async ({ entityId }: InviteAuthUserParameters) => {
  const response = await fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${entityId.toString()}/user/invite`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }
  )
  if (response.status === 200) return InviteAuthUserResult.Success
  else if (response.status === 404) return InviteAuthUserResult.UserUnavailable
  else throw Error(`Unexpected response code ${response.status} when inviting user for entity ${entityId.toString()}`)
}

export default inviteAuthUser
